import React from 'react';
import YouDeserveSection from './you-deserve-section';
import InnerCtaSection from './inner-cta-section';
import { Box } from '@mui/material';
import { JumpPageSectionProps } from '../jump-page-body';

const HeroSection: React.FC<JumpPageSectionProps> = ({ analytics }) => (
  <Box display="flex" flexDirection="column">
    <InnerCtaSection analytics={analytics} />
    <YouDeserveSection analytics={analytics} />
  </Box>
);

export default HeroSection;
